import { combineReducers } from "redux";
import user from "./user"
import experience from "./experience"
import education from "./education"
import references from "./references"
import strengths from "./strengths"

export default combineReducers({user, experience, education, references, strengths});